export default __webpack_public_path__ + "static/media/pro-min.46fc3564.png";